var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFbSmallDisplayIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2597",
    "data-name": "Group 2597",
    transform: "translate(-304 -208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M12,6a6,6,0,1,0-6.938,5.927V7.734H3.539V6H5.062V4.678A2.117,2.117,0,0,1,7.329,2.344a9.136,9.136,0,0,1,1.343.118V3.938H7.915a.867.867,0,0,0-.978.937V6H8.6L8.336,7.735h-1.4v4.191A6,6,0,0,0,12,6Z",
    transform: "translate(304 208)",
    fill: "rgba(66,82,106,0.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M154.324,104.444l.268-1.752h-1.681v-1.137a.876.876,0,0,1,.987-.946h.764V99.12a9.226,9.226,0,0,0-1.356-.12,2.138,2.138,0,0,0-2.288,2.357v1.335H149.48v1.752h1.539v4.234a6.123,6.123,0,0,0,1.894,0v-4.234Z",
    transform: "translate(158.033 111.249)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbSmallDisplayIcon);
export default __webpack_public_path__ + "static/media/fb-small-display-icon.1b464fa642182cc79f665dac1815bbce.svg";
export { ForwardRef as ReactComponent };